import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { REGISTRATION_URL, SITE, LOGO_URL } from "@/lib/config";

export default function AdminLogin() {
    const { user, login, initialized } = useAuth();
    const [form, setForm] = useState({ email: "", password: "" });
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    if (initialized && user && user.role === "admin") {
        return <Navigate to="/admin" replace />;
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        const result = await login(form.email.trim(), form.password);
        setLoading(false);
        if (result.ok) {
            navigate("/admin", { replace: true });
        } else {
            setError(result.error || "Credenciales inválidas");
        }
    };

    return (
        <div
            data-testid="admin-login-page"
            className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-4 py-16"
        >
            <div className="w-full max-w-md bg-white border border-[#E2E4E9] p-8 sm:p-10">
                <div className="mb-8">
                    <img
                        src={LOGO_URL}
                        alt={`Logo oficial de ${SITE.fullName}`}
                        className="h-10 w-auto mb-6"
                        width="160"
                        height="39"
                    />
                    <div className="text-xs uppercase tracking-widest text-[#082050]/70">
                        {SITE.name} · Administración
                    </div>
                    <h1 className="mt-2 text-2xl font-semibold text-[#082050] tracking-tight">
                        Acceder al panel
                    </h1>
                </div>
                <form onSubmit={onSubmit} className="space-y-5" data-testid="admin-login-form">
                    <div>
                        <label className="text-xs uppercase tracking-widest text-[#082050]/70">Email</label>
                        <input
                            type="email"
                            required
                            value={form.email}
                            onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
                            data-testid="admin-email"
                            className="mt-2 w-full border border-[#E2E4E9] px-4 py-3 text-sm focus:outline-none focus:border-[#082050]"
                        />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-widest text-[#082050]/70">Contraseña</label>
                        <input
                            type="password"
                            required
                            value={form.password}
                            onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
                            data-testid="admin-password"
                            className="mt-2 w-full border border-[#E2E4E9] px-4 py-3 text-sm focus:outline-none focus:border-[#082050]"
                        />
                    </div>
                    {error && (
                        <div data-testid="admin-login-error" className="text-sm text-red-600 border border-red-500 bg-red-50 px-4 py-3">
                            {error}
                        </div>
                    )}
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="btn-admin-login"
                        className="w-full bg-[#082050] text-white py-3 text-sm font-medium hover:bg-[#082050]/90 disabled:opacity-50"
                    >
                        {loading ? "Accediendo..." : "Acceder"}
                    </button>
                </form>
                <div className="mt-8 pt-8 border-t border-[#E2E4E9] text-xs text-[#718096]">
                    <a href="/" className="hover:text-[#082050]">← Volver al sitio</a>
                </div>
            </div>
        </div>
    );
}
